import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';


// import { library } from '@fortawesome/fontawesome-svg-core';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { faIconName } from '@fortawesome/free-solid-svg-icons'; // Reemplaza "IconName" con el nombre del icono que deseas

// library.add(faIconName);
// // Vue.component('font-awesome-icon', FontAwesomeIcon);


createApp(App).mount('#app')
